import { useQuery } from "@apollo/client";
import { Button, Typography, Box,Tooltip } from "@mui/material";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { Link ,useNavigate } from "react-router-dom";
import Card from "../../Components/Cards/Card";
import DataTable from "../../Components/Datatable";
import Stats from "../../Components/Stats";
import TableHeading from "../../Components/TableHeading";
import globals from "../../Constants/Globals";
import { GET_ALL_ORGANIZATIONS } from "../../Graphql/Queries";
import { SuperAdminPaths } from "../../Routes/Paths";
import { pages } from "../../Types/DatatableType";
import { DELETE_ORGANIZATION } from "../../Graphql/Mutations";
import { useMutation } from "@apollo/client";
import { Error } from '../../Types/MessageType';
import Message from '../../Components/Message';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import NoteAddIcon from '@mui/icons-material/NoteAdd'; // Import the icon
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'; // Import the icon
import BusinessIcon from '@mui/icons-material/Business';

const Organization = () => {
  const [searchCriteria, setSearchCriteria] = useState<{
    name: string;
    adminName: string;
    trainingModule: string;
    userCount?: number;
  }>({
    name: '',
    adminName: '',
    trainingModule: '',
   
  });
 const handleSearchChange = (field: string, value: string) => {
  setSearchCriteria((prev) => {
    const updatedCriteria = {
      ...prev,
      [field]: field === 'userCount' ? parseInt(value, 10) || 0 : value,
    };

    // Remove userCount from the payload if it is 0
    if (field === 'userCount' && (value === '' || parseInt(value, 10) === 0)) {
      delete updatedCriteria.userCount;
    }

    return updatedCriteria;
  });
};
 const { CREATE_ORGANIZATION_PATH } = SuperAdminPaths
 const [alert, setAlert] = useState<Error>({ type: 'warning', message: '' });
 const [tableData, setTableData] = useState<any[]>([]);
 const [totalPages, setTotalPages] = useState<pages>()
 const [currentPage, setCurrentPage] = useState<number>(1)
 const [orgCount,setOrgCount]=useState<number>(0);
 const { loading: organizationsLoading } = useQuery<any>(GET_ALL_ORGANIZATIONS, {
  variables: {
    page: currentPage,
    limit: globals.pageSize,
    search: searchCriteria, // userCount will only be included if explicitly set
  },
  onCompleted(data) {
    if (data.allOrganizations.organizations.length > 0) {
      const org = data?.allOrganizations?.organizations;
      setOrgCount(data?.allOrganizations?.totalDocs);
      setTotalPages({
        currentPage: data?.allOrganizations?.currentPage,
        limit: globals.pageSize,
        totalDocs: data.allOrganizations?.totalDocs,
        totalPages: data.allOrganizations?.totalPages,
      });
      setTableData([]);
      if (org.length > 0) {
        const _org = org.map((_singleOrg: any, index: number) => {
          return {
            key: index,
            orgId: _singleOrg._id,
            orgName: _singleOrg.name,
            orgAdmin: _singleOrg.adminName,
            orgImage: _singleOrg.image,
            trainingModule: _singleOrg.trainingPackage ? _singleOrg.trainingPackage.name : "",
            trainingModuleId: _singleOrg.trainingPackage ? _singleOrg.trainingPackage._id : "",
            noOfUsers: _singleOrg.activeUserCount || 0,
          };
        });
        setTableData(_org);
      }
    }
  },
 })

 
 const [deleteOrganization] = useMutation(DELETE_ORGANIZATION);
 const [open, setOpen] = useState(false);
 const [record,setRecord]=useState(null);
 const navigate = useNavigate()

 const handleClickOpen = (record:any) => {
  setRecord(record);
   setOpen(true);
 };

 const handleDelete = () => {
   handleDeleteOrganization(record);
   setOpen(false);
   setRecord(null);
 };

 const handleClose = ()=>{
  setOpen(false);
 }

 const handleDeleteOrganization = (record: any): void => {
    deleteOrganization({
        variables:{
          id:record.orgId
        },
        onCompleted(data) {
            const updatedTableData = tableData.filter(item => item.orgId !== record.orgId);
            setTableData(updatedTableData);
            setOrgCount(orgCount=>orgCount-1);
            setAlert({ type: "success", message: "Organization deleted successfully" })
            setTimeout(() => {
              setAlert({
                type: 'success',
                message: ''
              })
            }, globals.timeout)
          },
          onError(error) {
            setAlert({ type: 'error', message: error.message })
            setTimeout(() => {
              setAlert({
                type: 'error',
                message: ''
              })
            }, globals.timeout);
          }
    })
 }

 const columns: ColumnsType<any> = [
  {
    title: (
      <TableHeading
        heading="Organization Name"
        setSearch={(value) => handleSearchChange('name', value)}
        setPage={setCurrentPage}
      />
    ),
    dataIndex: "orgName",
    render: (text, record) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {record.orgImage ? (
          <img
            src={(record.orgImage)} 
            alt={text}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <BusinessIcon sx={{ fontSize: '40px', color: 'gray' }} />
        )}
        <Typography variant="body1" sx={{ textAlign: 'left' }}>
          {text}
        </Typography>
      </Box>
    ),
    key: "1",
    width: '26%',
  },
  {
    title: (
      <TableHeading
        heading="Organization Admin"
        setSearch={(value) => handleSearchChange('adminName', value)}
        setPage={setCurrentPage}
      />
    ),
    dataIndex: "orgAdmin",
    render: (text) => (
      <Typography variant="body1" sx={{ textAlign: 'left' }}>
        {text}
      </Typography>
    ),
    key: "2",
    width: '25%',
  },
  {
    title: (
      <TableHeading
        heading="Training Module"
        setSearch={(value) => handleSearchChange('trainingModule', value)}
        setPage={setCurrentPage}
      />
    ),
    dataIndex: "trainingModule",
    render: (text) => (
      <Typography variant="body1" sx={{ textAlign: 'left' }}>
        {text}
      </Typography>
    ),
    key: "3",
    width: '20%',
  },
  {
    title: (
      <TableHeading
        heading="No of Users"
        setSearch={(value) => handleSearchChange('userCount', value)}
        setPage={setCurrentPage}
      />
    ),
    dataIndex: "noOfUsers",
    render: (text) => (
      <Typography variant="body1" sx={{ textAlign: 'left' }}>
        {text || 0} {/* Default to 0 if no value */}
      </Typography>
    ),
    key: "4",
    width: '15%',
  },
  {
    title: '',
    render: (_, record) => (
      <Tooltip title="View Details" arrow>
        <IconButton
          sx={{ color: "rgb(250, 150, 157)" }}
          onClick={() => navigate(record.orgId, { state: { orgId: record.orgId } })}
        >
          <RemoveRedEyeIcon sx={{ fontSize: "1.8rem" }} />
        </IconButton>
      </Tooltip>
    ),
    key: "5",
  },
  {
    title: '',
    render: (_, record) => (
      <IconButton
        sx={{ alignSelf: 'flex-end' }}
        onClick={(e) => {
          e.stopPropagation(); 
          handleClickOpen(record); 
        }}
      >
        <DeleteIcon />
      </IconButton>
    ),
    key: "6",
  },
];

const handleRowClick = (record: any) => {
  navigate(`/organizations/${record.orgId}`, { state: { orgId: record.orgId } });
};

 return (
  <>
   <Stats
  buttonText={
    <>
      Create Organization <NoteAddIcon sx={{ color: 'white', ml: 1 }} />
    </>
  }
  text="Total Organizations"
  number={orgCount}
  link={CREATE_ORGANIZATION_PATH}
/>

   <Box flexGrow={1} sx={{ pr: 3 }}>
      {!!alert?.message ? <Message type={alert?.type} message={alert.message} variant={"filled"} /> : null}
   </Box>
   <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this organization?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>handleClose()}>Cancel</Button>
          <Button onClick={()=>handleDelete()} autoFocus>
            Confirm
          </Button>
        </DialogActions>
    </Dialog>

   <Card>
    <DataTable
     loading={organizationsLoading}
     tableData={tableData}
     totalPages={totalPages}
     showCheck={false}
     columnData={columns}
     page={(cp) => {
      setCurrentPage(Number(cp))
     }}
     scrollX="max-content"
     scrollY={450}
     onRow={(record) => handleRowClick(record)}
    />
   </Card>
  </>
 )

}

export default Organization;